import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Motion";
import { Target, Eye, Check } from "lucide-react";
import { IMAGES, VALUES, STRENGTHS, COMPANY } from "../data";

export default function About() {
  return (
    <div data-testid="about-page">
      <PageIntro
        label="About Mars Mining Limited"
        title="AI-driven mineral intelligence and strategic project development."
        subtitle="A UK-based mining intelligence and strategic advisory company enabling secure, sustainable and technology-driven access to critical minerals."
      />

      {/* Intro + image */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <Reveal className="relative aspect-[4/3] overflow-hidden rounded-lg shadow-card">
            <img src={IMAGES.engineers} alt="Mineral exploration" className="w-full h-full object-cover" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-bold text-3xl md:text-4xl leading-tight tracking-tight text-mm-ink">
              Technology and geoscience, working together.
            </h2>
            <p className="mt-6 text-lg text-mm-muted leading-relaxed">
              We combine artificial intelligence, geoscience, project development expertise and strategic partnerships to support governments, mining companies and investors across the critical minerals value chain.
            </p>
            <ul className="mt-8 space-y-3">
              {STRENGTHS.map((s) => (
                <li key={s} className="flex items-start gap-3 text-mm-ink">
                  <span className="h-6 w-6 rounded-md bg-mm-light flex items-center justify-center shrink-0 mt-0.5">
                    <Check size={14} className="text-mm-accent" />
                  </span>
                  <span className="text-mm-muted">{s}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="bg-mm-light border-y border-mm-line">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-28 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { icon: Target, k: "Mission", v: COMPANY.mission },
            { icon: Eye, k: "Vision", v: COMPANY.vision },
          ].map((m, i) => (
            <Reveal key={m.k} delay={i * 0.1}>
              <div className="h-full bg-white border border-mm-line rounded-lg p-10 shadow-card">
                <div className="h-12 w-12 rounded-md bg-mm-blue flex items-center justify-center">
                  <m.icon size={22} className="text-white" />
                </div>
                <h3 className="font-display font-bold text-2xl text-mm-ink mt-6">{m.k}</h3>
                <p className="text-lg text-mm-muted leading-relaxed mt-4">{m.v}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Values */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="max-w-2xl mb-14">
          <Reveal>
            <p className="overline mb-5">Why Mars Mining</p>
            <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl tracking-tight text-mm-ink">Principles that guide every engagement.</h2>
          </Reveal>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {VALUES.map((v, i) => (
            <Reveal key={v.num} delay={i * 0.08}>
              <div className="h-full bg-white border border-mm-line rounded-lg p-8 shadow-card">
                <span className="font-display font-extrabold text-5xl text-mm-line">{v.num}</span>
                <h3 className="font-display font-bold text-xl text-mm-ink mt-4">{v.title}</h3>
                <p className="text-mm-muted leading-relaxed mt-3">{v.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
